import React from 'react';
import './WhyPhoneVue.css';
import icon1 from '../../assets/icons/whyphonevue-icon01.svg';
import icon2 from '../../assets/icons/whyphonevue-icon02.svg';
import icon3 from '../../assets/icons/whyphonevue-icon3.svg';

const WhyPhoneVue = () => {
  const features = [
    {
      icon: (
        <img src={icon1} alt="Automated & Manual Diagnostics" />
      ),
      title: 'Automated & Manual Diagnostics',
      description: 'Diagnose up to 24 smartphone functions to detect signs of malfunction. Run automated checks or perform manual tests for camera, display, touch, buttons, and flash. Recommended for devices with slow response, heavy processing, or poor overall condition.'
    },
    {
      icon: (
        <img src={icon2} alt="Battery Deterioration Analysis" />
      ),
      title: 'Battery Deterioration Analysis',
      description: 'Check your smartphone\'s current battery deterioration with a single tap. Answer a short questionnaire to identify your battery usage type. View a battery degradation prediction graph for up to the next two years.'
    },
    {
      icon: (
        <img src={icon3} alt="Detailed Diagnostic Reports" />
      ),
      title: 'Detailed Diagnostic Reports',
      description: 'Access all diagnosis results in the Report section of PhoneVue. View recent and past test records categorized under Sensors, Hardware, and Wireless. Real-time data helps you understand your smartphone\'s current condition.'
    }
  ];

  return (
    <div className="why-phonevue-page">
      <div className="why-phonevue-container">
        <div className="why-phonevue-header">
          <p className="section-label">Diagnostic Advantages</p>
          <h1 className="section-title">Why PhoneVue?</h1>
        </div>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon-wrapper">
                {feature.icon}
              </div>
              <h3 className="feature-card-title">{feature.title}</h3>
              <p className="feature-card-description">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default WhyPhoneVue;
